import React, { useEffect, useState } from "react";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import AppointmentService from "../../../Services/AppointmentService";
import "./calendarStyle.css";
import { FaVideo } from "react-icons/fa";
import { IoPerson, IoPersonSharp } from "react-icons/io5";
import dayjs from "dayjs";
import { message, Modal, Tooltip } from "antd";
import { BiVideoPlus } from "react-icons/bi";
import { APP_ROUTES } from "../../../PageRouting/approutes";
import CommonFunctions from "../../Shared/CommonFunctions";
import ConsultationService from "../../../Services/ConsultationService";
import PatientService from "../../../Services/PatientService";
import { useHistory } from "react-router-dom";
import Layouts from "../../Layouts";
import UserService from "../../../Services/UserService";

const localizer = momentLocalizer(moment);

function AppointmentCalender() {
  const [events, setEvents] = useState([]);
  const [currentDate, setCurrentDate] = useState(new Date());
  const [currentView, setCurrentView] = useState("week");
  const history = useHistory();
  let loginData = localStorage.getItem("login_result");
  let loginDataObject = loginData ? JSON.parse(loginData) : null;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [clinicList, setClinicList] = useState([]);
  const [appointmentData, setAppointmentData] = useState(null);

  useEffect(() => {
    fetchAppointments(currentDate, currentView);
  }, []);

  useEffect(() => {
    getClincListDetails();
  }, []);

  const getDateRange = (date, view) => {
    const start = moment(date).startOf(view === "month" ? "month" : view);
    const end = moment(date).endOf(view === "month" ? "month" : view);
    return {
      fromDate: start.format("MM/DD/YYYY"),
      toDate: end.format("MM/DD/YYYY"),
    };
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const fetchAppointments = (date, view) => {
    const { fromDate, toDate } = getDateRange(date, view);
    const payload = {
      userId: loginDataObject.user.userId,
      account_Id: loginDataObject.user.account_Id,
      fromDate,
      toDate,
    };

    AppointmentService.ListForCalendar(payload).then((res) => {
      const mappedEvents = res.data.map((appointment) => ({
        title: appointment.patientName,
        start: new Date(
          `${moment(appointment.appointmentDate, "MM/DD/YYYY").format(
            "YYYY-MM-DD"
          )}T${dayjs(appointment.startTime, "hh:mm A").format("HH:mm")}`
        ),
        end: new Date(
          `${moment(appointment.appointmentDate, "MM/DD/YYYY").format(
            "YYYY-MM-DD"
          )}T${dayjs(appointment.endTime, "hh:mm A").format("HH:mm")}`
        ),
        colorCode: appointment.colorCode,
        data: {
          ...appointment,
          status: appointment.status,
          serviceCode: appointment.serviceCode,
        },
      }));
      setEvents(mappedEvents);
    });
  };

  const CustomToolbar = ({ label, onNavigate, onView }) => (
    <div className="rbc-toolbar margin">
      <span className="rbc-btn-group">
        <div className="cbtnstyle">
          <button
            type="button"
            onClick={() => onNavigate("PREV")}
            className="button1"
          >
            <FaArrowLeft className="text-white" />
          </button>

          <button
            type="button"
            onClick={() => onNavigate("NEXT")}
            className="button1"
          >
            <FaArrowRight className="text-white" />
          </button>
        </div>
      </span>
      <span className="rbc-toolbar-label ">{label}</span>
      <div className="flex items-center gap-2">
        <button
          onClick={() => onView("week")}
          className={` ${
            currentView == "week" ? "activeView" : "calenderbutton"
          }`}
        >
          Week
        </button>
        <button
          onClick={() => onView("day")}
          className={` ${
            currentView == "day" ? "activeView" : "calenderbutton"
          }`}
        >
          Day
        </button>
        <button
          onClick={() => onView("month")}
          className={` ${
            currentView == "month" ? "activeView" : "calenderbutton"
          }`}
        >
          Month
        </button>
        {/* <button onClick={() => onView("agenda")} className="calenderbutton">
          Agenda
        </button> */}
      </div>
    </div>
  );
  const handleJoinCall = (props) => {
    setAppointmentData(props.event.data);
    setIsModalOpen(true);
  };

  const components = {
    event: (props) => {
      const today = new Date();
      const eventStart = new Date(props.event.start);
      let bgColor = "";

      if (eventStart.toDateString() === today.toDateString()) {
        bgColor = `bg-[${props.event.colorCode}] h-full px-1`;
      } else if (eventStart > today) {
        bgColor = `bg-[${props.event.colorCode}] h-full px-1`;
      } else {
        bgColor = `bg-[${props.event.colorCode}] h-full px-1`;
      }

      return (
        <div
          onClick={() => handleJoinCall(props)}
          style={{ backgroundColor: props.event.colorCode }}
          className="flex max-w-[250px] items-center justify-between gap-2 px-2 py-1 h-full rounded-md shadow-sm backdrop-blur-sm  cursor-pointer text-xs transition-all hover:scale-[1.02]"
        >
          <span className="truncate font-medium">{props.title}</span>

          <span className="text-sm">
            {props.event.data.serviceCode === "APPT_VIDEO" ? (
              <FaVideo className="" />
            ) : (
              <IoPerson className="" />
            )}
          </span>
        </div>
      );
    },
  };

  const scrollToTime = moment().set({ hour: 8, minute: 0 }).toDate();

  const handleClick = (record, tab) => {
    if (record.clinic_Id !== loginDataObject.user.clinic_Id) {
      localStorage.setItem("defaultClinic", record.clinic_Id);
      const loginData = localStorage.getItem("login_result");
      const parsedLoginData = loginData ? JSON.parse(loginData) : null;
      const updatedData = {
        ...parsedLoginData,
        user: {
          ...parsedLoginData.user,
          clinic_Id: record.clinic_Id,
        },
      };
      localStorage.setItem("login_result", JSON.stringify(updatedData));
    }

    if (tab === "1") {
      let payload = {
        appointmentId: record.appointmentId,
        modifiedBy: record.userId,
        modifiedDate: CommonFunctions.convertUTCDate(
          new Date(),
          "YYYY-MM-DD HH:mm:ss"
        ),
        patientId: record.patientId,
        startDateTime: CommonFunctions.convertUTCDate(
          new Date(),
          "YYYY-MM-DD HH:mm:ss"
        ),
        userId: record.userId,
      };

      ConsultationService.updateStartTime(payload).then((res) => {
      });
    }
    record.callMode = tab == "1" ? "JoinCall" : "EditCall";
    let payload = {
      patientId: record.patientId,
    };

    PatientService.PatientListFilter(payload).then((res) => {
      localStorage.setItem("patient", JSON.stringify(res.data[0]));
    });
    history.push(APP_ROUTES.VIDEOCALL, { selectedPatient: record });
  };

  const getClincListDetails = async () => {
    const defaultData = localStorage.getItem("defaultClinic");

    let payload = {
      userId: loginDataObject.user.userId,
      status: 1,
    };

    try {
      let result = await UserService.UserMultipleClinicList(payload);
      setClinicList(result?.data[0]?.clinicDetailsList);
      const defaultClinic = result?.data[0]?.clinicDetailsList.find(
        (clinic) => clinic.clinic_Id == defaultData
      );
    } catch (error) {
      console.error("error", error);
    }
  };

  return (
    <Layouts>
      <div className="md:text-xl font-sans text-xl tracking-wider font-bold mb-3">
        Calendar View
      </div>
      <div className="flex flex-wrap gap-4 py-4 my-2">
        {clinicList &&
          clinicList.map((clinic) => (
            <div
              key={clinic.clinic_Id}
              className="flex items-center gap-2 text-md font-medium"
            >
              <div
                className="w-6 h-6 rounded-full"
                style={{ backgroundColor: clinic.colorCode }}
              ></div>
              <span>{clinic.clinicName}</span>
            </div>
          ))}
      </div>
      <div>
        <Calendar
          localizer={localizer}
          events={events}
          startAccessor="start"
          endAccessor="end"
          style={{ height: 800 }}
          components={{
            toolbar: CustomToolbar,
            event: components.event,
          }}
          scrollToTime={scrollToTime}
          defaultView="week"
          views={["month", "week", "day", "agenda"]}
          onNavigate={(date) => {
            setCurrentDate(date);
            fetchAppointments(date, currentView);
          }}
          onView={(view) => {
            setCurrentView(view);
            fetchAppointments(currentDate, view);
          }}
          dayLayoutAlgorithm="no-overlap"
        />

        {isModalOpen && (
          <Modal
            title={
              <h2 className="text-2xl  font-bold text-brand-primaryColor mb-6 border-b pb-2">
                Appointment Details
              </h2>
            }
            closable={{ "aria-label": "Custom Close Button" }}
            open={isModalOpen}
            onOk={handleOk}
            onCancel={handleCancel}
            footer={null}
          >
            <div className="bg-white rounded-md shadow-xl p-6 w-full max-w-2xl mx-auto border border-gray-100">
              {/* Patient Info */}
              <div className="flex justify-between items-center mb-4">
                <div>
                  <p className="text-sm text-gray-500">Account Name</p>
                  <p className="text-base font-semibold text-gray-800">
                    {appointmentData.account_Name}
                  </p>
                </div>
                <div>
                  <p className="text-sm text-gray-500">Clinic Name</p>
                  <p className="text-base font-semibold text-gray-800">
                    {appointmentData.clinic_Name}
                  </p>
                </div>
              </div>
              <div className="flex justify-between items-center mb-4">
                <div>
                  <p className="text-sm text-gray-500">Patient Name</p>
                  <p className="text-base font-semibold text-gray-800">
                    {appointmentData.patientName}
                  </p>
                </div>
                <div>
                  <p className="text-sm text-gray-500">Patient ID</p>
                  <p className="text-base font-semibold text-gray-800">
                    {appointmentData.patientId}
                  </p>
                </div>
              </div>

              {/* Date & Time */}
              <div className="flex justify-between items-center mb-4">
                <div>
                  <p className="text-sm text-gray-500">Appointment Date</p>
                  <p className="text-base font-semibold text-gray-800">
                    {appointmentData.appointmentDate}
                  </p>
                </div>
                <div>
                  <p className="text-sm text-gray-500">Time</p>
                  <p className="text-base font-semibold text-gray-800">
                    {appointmentData.startTime} - {appointmentData.endTime}
                  </p>
                </div>
              </div>

              {/* Service Info */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                <div className="md:col-span-2">
                  <p className="text-sm text-gray-500">Appointment Reason</p>
                  <p className="text-base font-medium text-gray-700">
                    {appointmentData.appointmentReason}
                  </p>
                </div>
              </div>

              <div className="mt-6 text-center flex justify-center items-center">
                {appointmentData.status === 2 ||
                appointmentData.status === 9 ? (
                  <button
                    className="flex items-center justify-center gap-2 w-28 px-1 py-2  bg-gray-400 text-white  rounded  cursor-not-allowed"
                    disabled
                  >
                    {appointmentData.serviceCode === "APPT_VIDEO" ? (
                      <>
                        <BiVideoPlus className="w-5 h-5" />
                        Join call
                      </>
                    ) : (
                      <>
                        <IoPersonSharp className="w-5 h-5" /> Consult
                      </>
                    )}
                  </button>
                ) : !appointmentData.transactionId &&
                  appointmentData.paymentConsultation === "BC" ? (
                  <Tooltip placement="top" title={"payment is not completed"}>
                    <button
                      className="bg-gray-400 text-white px-3 w-28 py-2 rounded flex items-center gap-1"
                      disabled
                    >
                      {appointmentData.serviceCode === "APPT_VIDEO" ? (
                        <>
                          <BiVideoPlus className="w-5 h-5" />
                          Join call
                        </>
                      ) : (
                        <>
                          <IoPersonSharp className="w-5 h-5" /> Consult
                        </>
                      )}
                    </button>
                  </Tooltip>
                ) : (
                  <button
                    onClick={() => handleClick(appointmentData, "1")}
                    className="bg-brand-primaryColor text-white px-3 w-28 py-2 rounded flex items-center gap-1"
                  >
                    {appointmentData.serviceCode === "APPT_VIDEO" ? (
                      <>
                        <BiVideoPlus className="w-5 h-5" />
                        Join call
                      </>
                    ) : (
                      <>
                        <IoPersonSharp className="w-5 h-5" /> Consult
                      </>
                    )}
                  </button>
                )}
              </div>
            </div>
          </Modal>
        )}
      </div>
    </Layouts>
  );
}

export default AppointmentCalender;
